import { Dialog, Stack, ActionButton, getTheme } from "@fluentui/react";
import { Dispatch, SetStateAction } from "react";

import { TypeOfQueryParam } from "../..";

interface DocumentOrLineModalProps {
  documentOrLineModalOpen: boolean;
  handlePickInputType: (type: TypeOfQueryParam) => void;
  setDocumentOrLineModal: Dispatch<
    SetStateAction<{
      documentOrLineModalOpen: boolean;
      candidateInputValue?: string;
    }>
  >;
}

const theme = getTheme();

export function DocumentOrLineModal({
  documentOrLineModalOpen,
  handlePickInputType,
  setDocumentOrLineModal
}: DocumentOrLineModalProps) {
  const handleOptionClick = (type: TypeOfQueryParam) => {
    handlePickInputType(type);
  };

  const buttonStyles = {
    root: {
      backgroundColor: theme.palette.neutralLighter,
      padding: "20px 30px",
      marginTop: "10px",
      height: "auto",
      minWidth: "120px"
    },
    icon: {
      fontSize: "24px"
    },
    label: {
      fontSize: "16px",
      fontWeight: "600"
    }
  };

  return (
    <Dialog
      hidden={!documentOrLineModalOpen}
      onDismiss={() => {
        setDocumentOrLineModal(prev => ({
          ...prev,
          documentOrLineModalOpen: false
        }));
      }}
      dialogContentProps={{
        title: "Qual tipo do dado informado?"
      }}
      minWidth={"350px"}
    >
      <Stack horizontal horizontalAlign="center" tokens={{ childrenGap: 20 }}>
        <ActionButton
          iconProps={{ iconName: "ContactCard" }}
          onClick={() => handleOptionClick("document")}
          styles={buttonStyles}
          aria-label="Buscar por CPF"
        >
          CPF
        </ActionButton>
        <ActionButton
          iconProps={{ iconName: "Phone" }}
          onClick={() => handleOptionClick("lineNumber")}
          styles={buttonStyles}
          aria-label="Buscar por linha telefônica"
        >
          Linha
        </ActionButton>
      </Stack>
    </Dialog>
  );
}
